import { Component, Injector, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ProjectService } from '../services/project/project.service';
import { ProjectGeneralInfo } from '../shared/model/project-general-info.model';
import { ContactItem } from '../shared/model/contact-item.model';
import { ContactService } from '../services/contact/contact.service';
import { Contact } from '../shared/model/contact.model';
import { SubmittalService } from '../services/submittal/submittal.service';
import { SearchSubmittalModel } from '../shared/model/SearchSubmittal.model';
import { PagedSubmittalList } from '../services/project/paged-submittal-list';
import { MeetingModel } from '../shared/model/meeting.model';
import { MeetingService } from '../services/meeting/meeting.service';
import { SubmittalListItem } from '../services/project/submittal';
import { AttachmentsModalComponent } from '../attachments-modal/attachments-modal.component';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { AttachmentsService } from '../services/attachments/attachments.service';
import { Action } from 'ngx-bootstrap/mini-ngrx';
import { BaseComponent } from '../base/base.component';
import { ModalContentComponent } from '../modal-content/modal-content.component';
import { Sort } from '../UI-Components/Sort/sort';

@Component({
  selector: 'app-project-details',
  templateUrl: './project-details.component.html',
  styleUrls: ['./project-details.component.css']
})
//export class ProjectDetailsComponent extends BaseComponent implements OnInit {
export class ProjectDetailsComponent  implements OnInit {

  private route: ActivatedRoute;
  private projectId: string;
  private projectService: ProjectService;
  projectGeneralInfo: ProjectGeneralInfo;
  contactDetailList: ContactItem[];
  contactService: ContactService;
  contactList: Contact[];
  submissions = [];
  submittalService: SubmittalService;
  searchModel: SearchSubmittalModel;
  meetingList: MeetingModel[];
  meetingService: MeetingService;
  router: Router;
  dialogService: NgbModal;

  constructor(public _injector: Injector, private _attachmentService: AttachmentsService) {
    // super(_injector);
    this.route = this._injector.get(ActivatedRoute);
    this.projectService = this._injector.get(ProjectService);
    this.contactService = this._injector.get(ContactService)
    this.submittalService = this._injector.get(SubmittalService);
    this.meetingService = this._injector.get(MeetingService);
    this.router = this._injector.get(Router);
    this.dialogService = this._injector.get(NgbModal);


    if (this.route.snapshot.paramMap.has('id')) {
      this.projectId = this.route.snapshot.paramMap.get('id');
    }

    this.projectGeneralInfo = new ProjectGeneralInfo("", "", [], "", "", "", "", "", "", "", "", "", "", "", "", "", "")
  }

  ngOnInit(): void {
    if (this.projectId != undefined) {
      this.CallAndLoadProjectInfo();
      this.contactService.GetProjectContacts(this.projectId).subscribe(contactList => {
        this.contactList = contactList;
        this.contactDetailList = [];
        this.GetContactItems();
      });
      this.searchModel = new SearchSubmittalModel(this.projectId, '', '', '', null, '', null, null, 0, 100, 1, null);
      if (this.searchModel.sort == null) {
        this.searchModel.sort = new Sort();
      }
      this.searchModel.sort.SetSorting('Publish Date');
  
      this.CallForProjectSubmittals();
      this.meetingService.GetProjectMeetings(this.projectId).subscribe(meetingList => {
        this.meetingList = meetingList;
      });
    }
  }

  private CallForProjectSubmittals() {
    this.submittalService.GetSubmittalsByProject(this.searchModel).subscribe(submissions => {
      this.LoadSubmissionList(submissions);
    });
  }

  private CallAndLoadProjectInfo() {
    this.projectService.GetProject(this.projectId).subscribe(project => {
      this.projectGeneralInfo = project;
    });
  }

  LoadSubmissionList(submissionsList: PagedSubmittalList) {
    if (submissionsList.list !== null && submissionsList.list.length !== 0) {
      this.submissions = submissionsList.list;
    } else if (submissionsList.totalRecords === 0) {
      this.submissions = undefined;
    }
  }

  private GetContactItems() {
    for (var contactItem of this.contactList) {
      this.contactService.GetContact(contactItem.externalContactId).subscribe(c => {
        let loadingContact = this.contactList.find(i => i.externalContactId == c.content.contactId);
        this.contactDetailList.push(new ContactItem(null, null, c.content.partyId, c.content.person? c.content.person.firstName: "", c.content.person ? c.content.person.lastName : "", null, null,
          c.content.contactId, null, c.content.email, null, null, c.content.addresses, c.content.phones, c.content.person ? c.content.person?.partyId : c.content.organization.PartyId,
          c.content.contactRoleId, c.content.contactRoleName, c.content.person, c.content.organization, null, null, null, null, loadingContact.contactId));
      });
    }
  }

  BackClick() {
    this.router.navigateByUrl('/search');
  }

  GoToSubmittal(submittal: SubmittalListItem) {
    if (submittal.intake == false) {
      this._attachmentService.GetAttachmentListBySubmittalId(submittal.submittalId).subscribe(attachments => {       
        if (attachments.length > 0)
          this.OpenModalAttachments(submittal);
        else  
        {    
          this._attachmentService.setMessage("Attachments does not exists.");
          this._attachmentService.setTitle("Attachments");
       
          let options: NgbModalOptions = {
            size: 'lg',
            backdrop: 'static',
            keyboard: false, 
            centered: true            
          };          
           this.dialogService.open(ModalContentComponent, options);   
        }
      })
    }
    else
    {
      this.submittalService.setEeaNumber(this.projectGeneralInfo.eeaNo);
      this.submittalService.setProjectName(this.projectGeneralInfo.projectName);
    }
  }

  OpenModalAttachments(submittal: SubmittalListItem) {
    const modalRef = this.dialogService.open(AttachmentsModalComponent);
    modalRef.componentInstance.submittalId = submittal.submittalId;
  }

  Print() {
    window.print();
  }

  onSort(colName: string): void {
    if (this.searchModel.sort == null) {
      this.searchModel.sort = new Sort();
    }
    this.searchModel.sort.SetSorting(colName);
    this.CallForProjectSubmittals();
  }

   // Function to get the organization name or doBusinessAs                                                        
  getDisplayName(item: any): string {                                                                             
    if (item.contactRoleName === 'Proponent') {                                                                   
      return item.organization && (item.organization.doBusinessAs || item.organization.organizationName) || '';   
    } else {                                                                                                      
      return item.organization && item.organization.organizationName === '-'                                      
        ? ''                                                                                                      
        : (item.organization && item.organization.organizationName) || '';                                        
    }                                                                                                             
  }                                                                                                               
}

